import styled from 'styled-components';

type Container = {
  loading: string;
  documents: number;
}

export const Container = styled.div<Container>`
  display: flex;
  flex: 1;
  margin-top: 20px;
  flex-direction: row;
  background: #EFEFEF;
  align-items: ${props => props.loading === 'true' || props.documents === 0 ? 'center' : ''};
  justify-content: ${props => props.loading === 'true' || props.documents === 0 ? 'center' : ''};
  padding: ${props => props.loading === 'true' || props.documents === 0 ? '30px 0' : '0'};
`;

export const ListSubsidiaries = styled.ul`
  max-width: 300px;
  min-width: 300px;
  background: #364863;

  li {
    a {
      display: block;
      color: #ffffff;
      padding: 20px 30px;
      transition: all .5s;

      &:hover, &:active, &.active {
        color: #0E4C54;
        background: #EFEFEF;
      }
    }
  }

  @media only screen and (max-width: 670px){
    max-width: 220px;
    min-width: 220px;
    
    li {
      a {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

type Companies = {
  companies: number;
}

export const ListDocumentsSudsidiaries = styled.div<Companies>`
  padding: 20px 30px;
  display: grid;
  grid-template-columns: ${props => `repeat(${props.companies > 1 ? 2 : 1}, 1fr)}`};
  grid-auto-flow: row;
  grid-gap: 10px;

  & > div {
    h2 {
      font-size: 18px;
      color: #0E4C54;
      font-weight: 700;
    }

    ul {
      margin: 30px 0 40px 16px;

      li {
        list-style: disc;
        font-size: 14px;
        
        + li {
          margin-top: 10px;
        }

        a {
          color: #0E4C54;
          display: block;
          transition: filter .2s;

          &:hover {
            filter: brightness(0.4);
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1024px){
    grid-template-columns: repeat(1, 1fr);
  }
`;
